import React, { useState } from 'react';

const CollapsedText = ({ pageDescription }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const charactersLimit = 362;

  const description = typeof pageDescription === 'string' ? pageDescription : '';

  const toggleSeeMore = () => {
    setIsExpanded(!isExpanded);
  };

  const displayedText = isExpanded ? description : description.slice(0, charactersLimit) + '...';

  return (
    <div className="mx-4 desktop:mx-0 desktop:mb-8">
      <div className="flex flex-col text-mglGray800">
        <span dangerouslySetInnerHTML={{ __html: displayedText }}></span>
      </div>
      <button onClick={toggleSeeMore} className="mt-2 flex items-center border-none bg-transparent text-mglBlue400">
        {!isExpanded ? (
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" className="mr-1">
            <path fill="currentColor" d="M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6l-6-6z" />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" className="mr-1">
            <path fill="currentColor" d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6l-6 6z" />
          </svg>
        )}
        <span>{!isExpanded ? 'Mais informações' : 'Menos informações'}</span>
      </button>
    </div>
  );
};

export default CollapsedText;
